import { render, staticRenderFns } from "./tabs-session-details.vue?vue&type=template&id=14410978&scoped=true&"
import script from "./tabs-session-details.vue?vue&type=script&lang=js&"
export * from "./tabs-session-details.vue?vue&type=script&lang=js&"
import style0 from "./tabs-session-details.vue?vue&type=style&index=0&id=14410978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14410978",
  null
  
)

export default component.exports